module.exports = __webpack_public_path__ + "static/media/largeMedal_1.30547fe1.png";